
import { TestPreviewComponent } from './modules/test-preview/test-preview.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './core/auth/auth-guard.service';
import { ErrorPageComponent } from './modules/error-page/error-page.component';
import { VoipModule } from './modules/voip/voip.module';
import { ComplaintAdminRoutingModule } from './modules/complaint-admin/complaint-admin-routing.module';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'profile',
    pathMatch: 'full',
  },
  // { path: '', loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule) },
  // { path: 'home', loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule) },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'education-admin',
    loadChildren: () =>
      import('./modules/education-admin/education-admin.module').then((m) => m.EducationAdminModule),
  },
  {
    path: 'education-user',
    loadChildren: () =>
      import('./modules/education-user/education-user.module').then((m) => m.EducationUserModule),
  },
  {
    path: 'consultation-lawyer',
    loadChildren: () =>
      import('./modules/consultation-lawyer/consultation-lawyer.module').then((m) => m.ConsultationLawyerModule),
  },
  {
    path: 'lawyer-managment',
    loadChildren: () =>
      import('./modules/lawyer-managment/lawyer-managment.module').then((m) => m.ConsultationAdminModule),
  },
  {
    path: 'consultation-user',
    loadChildren: () =>
      import('./modules/consultation-user/consultation-user.module').then((m) => m.ConsultationUserModule),
  },
  {
    path: 'consultation-admin',
    loadChildren: () =>
      import('./modules/consultation-admin/consultation-admin.module').then((m) => m.ConsultationAdminModule),
  },
  {
    path: 'voip',
    loadChildren: () =>
      import('./modules/voip/voip.module').then((m)=> m.VoipModule)
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./modules/settings/settings.module').then((m) => m.SettingsModule),
  },
  {
    path: 'log',
    loadChildren: () =>
      import('./modules/log/log.module').then((m) => m.LogModule),
  },
  {
    path: 'petition-builder',
    loadChildren: () =>
      import('./modules/petition-builder/petition-builder.module').then((m) => m.PetitionBuilderModule),
  },
  {
    path: 'petition-user',
    loadChildren: () => import('./modules/petition-user/petition-user.module').then((m) => m.PetitionUserModule),
  },
  {
    path: 'petition-lawyer',
    loadChildren: () => import('./modules/petition-lawyer/petition-lawyer.module').then((m)=> m.PetitionLawyerModule),
  },
  {
    path: 'petition-admin',
    loadChildren: () =>
      import('./modules/petition-admin/petition-admin.module').then((m) => m.PetitionAdminModule),
  },
  {
    path: 'news',
    loadChildren: () =>
      import('./modules/news/news.module').then((m) => m.NewsModule),
  },
  {
    path: 'profile',
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import('./modules/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'user-managment',
    loadChildren: () =>
      import('./modules/user-managment/user-managment.module').then((m) => m.UserManagmentModule),
  },
  {
    path: 'user-tickets',
    loadChildren: () =>
      import('./modules/tickets-user/tickets-user.module').then((m) => m.TicketsUserModule),
  },
    {
    path: 'customers-admin',
    loadChildren: () =>
      import('./modules/manage-customers/manage-customers.module').then(
        (m) => m.ManageCustomersModule
      ),
  },
  {
    path: 'admin-tickets',
    loadChildren: () =>
      import('./modules/tickets-admin/tickets-admin.module').then((m) => m.TicketsAdminModule),
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import('./modules/notification/notification.module').then((m) => m.NotificationModule),
  },
  {
    path: 'payment',
    loadChildren: () => import('./modules/payment/payment.module').then((m) => m.PaymentModule),
  },
  {
    path: 'workflow',
    loadChildren: () =>
      import('./modules/workflow/workflow.module').then((m) => m.WorkflowModule),
  },
  {
    path: 'contract-user',
    loadChildren: () =>
      import('./modules/contract-user/contract-user.module').then((m) => m.ContractUserModule),
  },
  {
    path: 'contract-admin',
    loadChildren: () =>
      import('./modules/contract-admin/contract-admin.module').then((m) => m.ContractAdminModule),
  },
  {
    path: 'contract-lawyer',
    loadChildren: () => import('./modules/contract-lawyer/contract-lawyer.module').then((m) => m.ContractLawyerModule),
  },
  {
    path: 'complaint-user',
    loadChildren: () => import('./modules/complaint-user/user-complaint.module').then((m) => m.UserComplaintModule),
  },
  {
    path: 'complaint-admin',
    loadChildren: () => import('./modules/complaint-admin/complaint-admin.module').then((m) => m.ComplaintAdminModule),
  },
  {
    path: 'complaint-lawyer',
    loadChildren: () => import('./modules/complaint-lawyer/complaint-lawyer.module').then((m) => m.LawyerComplaintModule),
  },
  {
    path: 'judicial-user',
    loadChildren: () => import('./modules/judicial-user/judicial-user.module').then((m) => m.JudicialUserModule),
  },
  {
    path: 'judicial-lawyer',
    loadChildren: () => import('./modules/judicial-lawyer/judicial-lawyer.module').then((m) => m.JudicialLawyerModule),
  },
  {
    path: 'judicial-admin',
    loadChildren: () => import('./modules/judicial-admin/judicial-admin.module').then((m) => m.JudicialAdminModule),
  },
  {
    path: 'package-admin',
    loadChildren: ()=> import('./modules/package-admin/package-admin.module').then((m)=> m.PackageAdminModule)
  },
  {
    path: 'package-user',
    loadChildren: () => import('./modules/package-user/package-user.module').then((m) => m.PackageUserModule)
  },
  {
    path: 'develop-test',
    component: TestPreviewComponent,
  },
  {
    path: 'chat',
    loadChildren: () =>
      import('./modules/chat-list/chat-list.module').then((m) => m.ChatListModule),
  },
  {
    path: 'p',
    loadChildren: () => import('./modules/public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'manage-users',
    loadChildren: () =>
      import('./modules/manage-invited-users/manage-invited-users.module').then((m) => m.ManageInvitedUsersModule),
  },
  {
    path: 'products-user',
    loadChildren: () => 
      import('./modules/products-user/products-user.module').then((m) => m.ProductsDetailModule)
  },
  {
    path: 'seo-managment',
    loadChildren: () =>
      import('./modules/seo-managment/seo-managment.module').then((m) => m.SeoManagmentModule),
  },
  {
    path: 'tutorial',
    loadChildren: () =>
      import('./modules/tutorial/tutorial.module').then((m) => m.TutorialModule),
  },
  {
    path: 'campaign',
    loadComponent: () => import('./modules/campaign/admin-campaign-list/admin-campaign-list.component').then(m => m.AdminCampaignListComponent),
  },
  {
    path: '**',
    pathMatch: 'full',
    component: ErrorPageComponent,
    data: { properties: ['no-auth', 'no-sidebar', 'no-footer'] },
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuardService]
})
export class AppRoutingModule { }
